import { Circle, Marker, Pane, Tooltip, useMapEvents } from "react-leaflet";
import { OperationNames } from "Types/operation";
import { useAppDispatch, useAppSelector } from "Hooks/useRedux";

import MapContainer from "Components/MapContainer";

import PathRoute from "./trafficPathes/route";
import Points from "./Points";
import Route from "./Route";
import Stations from "./trafficStations";
import Zones from "./trafficZones";
import TravelHeatMap2 from "./travelHeatMap2";
import TrafficHeatMap2 from "./trafficHeatMap2";
import TravelHeatMap from "./heatMapGradian/travelHeatMap";
import TrafficHeatMap from "./heatMapGradian/trafficHeatMap";
import Travel from "./travel";
import Traffic from "./traffic";
import TrafficFleet from "./trafficFleet";
import TrafficMarkerCluster from "./clusters/trafficMarkerCluster";
import TravelMarkerCluster from "./clusters/travelMarkerCluster";
import TrafficFleetMarkerCluster from "./clusters/trafficFleetMarkerCluster";
import CameraMarkerCluster from "./clusters/cameraMarkerCluster";
import Events from "./event";
import Waybill from "./waybill";
import WaybillMarkerCluster from "./clusters/waybillMarkerCluster";
import WaybillHeatMap from "./heatMapGradian/waybillHeatmap";
import Passage from "./passage";
import MarginPark from "./marginPark";
import MarginParkHeatMap from "./heatMapGradian/marginParkHeatMap";
import MarginParkMarkerCluster from "./clusters/marginParkMarkerCluster";
import EventMarkerCluster from "./clusters/eventMarkerCluster";
import TrafficFleetHeatMap from "./heatMapGradian/trafficFleetHeatMap";
import Camera from "./camera";
import TrafficPathArcAndShadow from "./trafficPathes/arcAndShadow";
import TrafficLinePath from "./trafficPathes/line";

const ICON_SIZE = 22;

function MapHandler() {
  const dispatch = useAppDispatch();

  const map = useMapEvents({
    click(e) {
      const { lat, lng } = e.latlng;
      const center = { lat, lng };
      const operationName: OperationNames[] = ["create-path", "edit-path"];
      // if (name !== null && operationName.includes(name)) dispatch(changeModal({ status: "add-station", data: { ...center } }));
    },
  });
  return <></>;
}

export default function Map() {
  const {
    travelShowType,
    pointwiseShow: travelPointwiseShow,
    markerMode: travelMarkerMode,
  } = useAppSelector((state) => state.travel);

  const { pointwiseShow: eventPointwiseShow } = useAppSelector((state) => state.event);

  const {
    waybillShowType,
    pointwiseShow: waybillPointwiseShow,
    markerMode: waybillMarkerMode,
  } = useAppSelector((state) => state.waybill);

  const { marginParkShowType, pointwiseShow: marginParkPointwiseShow } = useAppSelector((state) => state.marginPark);

  const {
    trafficShowType,
    pointwiseShow: trafficPointwiseShow,
    // markerMode: travelMarkerMode,
  } = useAppSelector((state) => state.traffic);
  const { starDashboardVisible } = useAppSelector((state) => state.services);
  const { pointwiseShow: trafficFleetPointwiseShow, trafficFleetShowType } = useAppSelector((state) => state.trafficFleet);
  const { page } = useAppSelector((state) => state.page);
  const { pointwiseShow: cameratPointwiseShow } = useAppSelector((state) => state.camera);

  const handleTravelShowType = () => {
    if (travelShowType === 0) {
      if (travelPointwiseShow) {
        return <Travel />;
      }
      return <TravelMarkerCluster />;
    }
    if (travelShowType === 1) {
      return <TravelHeatMap />;
    }
    if (travelShowType === 2) {
      return <TravelHeatMap2 />;
    }
    return <></>;
  };

  const handleTrafficShowType = () => {
    if (trafficShowType === 0) {
      if (trafficPointwiseShow) {
        return <Traffic />;
      }
      return <TrafficMarkerCluster />;
    }
    if (trafficShowType === 1) {
      return <TrafficHeatMap />;
    }
    if (trafficShowType === 2) {
      return <TrafficHeatMap2 />;
    }
    return <></>;
  };

  const handleWaybillShowType = () => {
    if (waybillShowType === 0) {
      if (waybillPointwiseShow) {
        return <Waybill />;
      }
      return <WaybillMarkerCluster />;
    }
    if (waybillShowType === 1) {
      return <WaybillHeatMap />;
    }
    if (waybillShowType === 2) {
      return <TravelHeatMap2 />;
    }
    return <></>;
  };

  const handleMarginParkShowType = () => {
    if (marginParkShowType === 0) {
      if (marginParkPointwiseShow) {
        return <MarginPark />;
      }
      return <MarginParkMarkerCluster />;
    }
    if (marginParkShowType === 1) {
      return <MarginParkHeatMap />;
    }
    if (marginParkShowType === 2) {
      return <TravelHeatMap2 />;
    }
    return <></>;
  };

  const handleTrafficFleetShowType = () => {
    if (trafficFleetShowType === 0) {
      if (trafficFleetPointwiseShow) {
        return <TrafficFleet />;
      }
      return <TrafficFleetMarkerCluster />;
    }
    if (trafficFleetShowType === 1) {
      return <TrafficFleetHeatMap />;
    }
    return <></>;
  };

  const handleEventShowType = () => {
    if (eventPointwiseShow) {
      return <Events />;
    }
    return <EventMarkerCluster />;
  };

  return (
    <MapContainer>
      <MapHandler />
      {page === 3 ? (
        <>
          {" "}
          <Stations />
          <Passage />
          {cameratPointwiseShow ? <Camera /> : <CameraMarkerCluster />}
          {handleMarginParkShowType()}
          {handleWaybillShowType()}
          {handleTravelShowType()}
          {handleTrafficShowType()}
          {handleEventShowType()}
          {handleTrafficFleetShowType()}
          <Zones />
          <TrafficPathArcAndShadow />
          <TrafficLinePath />
        </>
      ) : null}
    </MapContainer>
  );
}
